import React, { useState, useEffect } from "react";
import { Table, Badge } from 'react-bootstrap';
// Certifique-se de exportar geo_buscar_escola no seu arquivo de api
import { geo_buscar_escola } from "../../services/api";

const Geo_lista_escolas = ({ unidade, range, onDataProcessed }) => {
    // Estados
    const [dadosEscolas, setDadosEscolas] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: 'nome', direction: 'asc' });

    // Função auxiliar para mapear a dependência
    const getDependenciaNome = (tipo) => {
        switch (tipo) {
            case 1: return "Federal";
            case 2: return "Estadual";
            case 3: return "Municipal";
            case 4: return "Particular";
            default: return "Não Informado";
        }
    };

    const fetchData = async () => {
        try {
            const response = await geo_buscar_escola(unidade, range);
            const listaSaneada = Array.isArray(response) ? response : (response?.data || []);

            // Formatando e mapeando os dados da API para o formato da tabela
            const dadosFormatados = listaSaneada.map(escola => {
                // Filtra valores nulos/vazios e junta com ' - '
                const partesEndereco = [
                    escola.ds_endereco,
                    escola.nu_endereco,
                    escola.ds_complemento,
                    escola.co_cep
                ].filter(Boolean).join(' - ');

                return {
                    nome: escola.no_entidade,
                    municipio: escola.no_municipio,
                    dependencia: getDependenciaNome(escola.tp_dependencia),
                    bairro: escola.no_bairro,
                    endereco: partesEndereco
                };
            });

            setDadosEscolas(dadosFormatados);

            // COMUNICAÇÃO COM O MESTRE: Envia a contagem de escolas para o rodapé unificado
            if (onDataProcessed) {
                onDataProcessed(dadosFormatados.length);
            }

        } catch (error) {
            console.error("Erro ao buscar dados das escolas:", error);
            setDadosEscolas([]);
            if (onDataProcessed) onDataProcessed(0);
        }
    };

    useEffect(() => {
        // Só busca os dados se unidade e range estiverem disponíveis
        if (unidade && range) {
            fetchData();
        }
    }, [unidade, range]);

    // Função de Ordenação
    const requestSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const sortedData = [...dadosEscolas].sort((a, b) => {
        let valA = a[sortConfig.key] || "";
        let valB = b[sortConfig.key] || "";

        // Converter para maiúsculo para ordenação alfabética case-insensitive
        if (typeof valA === 'string') valA = valA.toUpperCase();
        if (typeof valB === 'string') valB = valB.toUpperCase();

        if (valA < valB) return sortConfig.direction === 'asc' ? -1 : 1;
        if (valA > valB) return sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
    });

    // Helper para ícones de ordenação
    const getSortIcon = (key) => {
        if (sortConfig.key !== key) return " ↕";
        return sortConfig.direction === 'asc' ? " 🔼" : " 🔽";
    };

    return (
        <div className="table-responsive" style={{ maxHeight: '60vh' }}>
            <Table striped bordered hover size="sm" className="align-middle bg-white m-0">
                <thead className="table-dark text-center sticky-top">
                    <tr style={{ fontSize: '12px', cursor: 'pointer' }}>
                        <th onClick={() => requestSort('nome')} className="align-middle" style={{ minWidth: '250px' }}>
                            NOME {getSortIcon('nome')}
                        </th>
                        <th onClick={() => requestSort('municipio')} className="align-middle">
                            MUNICÍPIO {getSortIcon('municipio')}
                        </th>
                        <th onClick={() => requestSort('bairro')} className="align-middle">
                            BAIRRO {getSortIcon('bairro')}
                        </th>
                        <th onClick={() => requestSort('dependencia')} className="align-middle text-nowrap">
                            DEPENDÊNCIA {getSortIcon('dependencia')}
                        </th>
                        <th onClick={() => requestSort('endereco')} className="align-middle" style={{ minWidth: '350px' }}>
                            ENDEREÇO {getSortIcon('endereco')}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {sortedData.length > 0 ? (
                        sortedData.map((item, index) => (
                            <tr key={index} className="text-center">
                                <td className="text-start fw-bold small text-primary">{item.nome}</td>
                                <td className="small">{item.municipio}</td>
                                <td className="small">{item.bairro}</td>
                                <td>
                                    <Badge bg={item.dependencia === 'Particular' ? 'warning' : 'info'} text={item.dependencia === 'Particular' ? 'dark' : 'light'}>
                                        {item.dependencia}
                                    </Badge>
                                </td>
                                <td className="text-start small text-muted">{item.endereco}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="5" className="text-center py-4 text-muted">
                                Nenhuma escola encontrada para a região selecionada.
                            </td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </div>
    );
}

export default Geo_lista_escolas;